module.exports = __webpack_public_path__ + "static/media/automate_kpi_icon.707bd6a3.png";